import { Button, EpicIcons } from "@constellation-academy/epic-ui";
import { useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type createMatrixElementButton_CreateMatrixElementMutation } from "@relay/createMatrixElementButton_CreateMatrixElementMutation.graphql";
import { CREATE_MATRIX_ELEMENT_MUTATION } from "./create-matrix-element-button.graphql";
import { type CreateMatrixElementButtonProps } from "./create-matrix-element-button.types";
import { useDraftStatusUpdater } from "../use-draft-status-updater";

export const CreateMatrixElementButton = ({
	eLearningContentNodeId,
}: CreateMatrixElementButtonProps) => {
	const { t } = useTranslation("common");
	const setDraft = useDraftStatusUpdater();
	const [createMatrixElement, isCreatingMatrixElement] =
		useMutation<createMatrixElementButton_CreateMatrixElementMutation>(
			CREATE_MATRIX_ELEMENT_MUTATION,
		);

	return (
		<Button
			disabled={isCreatingMatrixElement}
			tooltip={t("educationalOffer.createMatrixElementTooltip")}
			icon={EpicIcons.TH_LARGE}
			onClick={() => {
				createMatrixElement({
					variables: {
						input: {
							title: t("educationalOffer.newElement"),
							correctAnswer: t("educationalOffer.correctAnswer"),
							firstColumnTitle: t("educationalOffer.newColumn"),
							firstRowTitle: t("educationalOffer.newRow"),
							eLearningContentId: eLearningContentNodeId,
						},
					},
					updater: setDraft,
				});
			}}
		/>
	);
};
